export default "__VITE_ASSET__C$c_2Ug3__"